import { render } from "./GeraContrato.vue?vue&type=template&id=333a4881&scoped=true"
import script from "./GeraContrato.vue?vue&type=script&lang=js"
export * from "./GeraContrato.vue?vue&type=script&lang=js"

import "./GeraContrato.vue?vue&type=style&index=0&id=333a4881&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333a4881"]])

export default __exports__